/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `stable_threshold` - stable_threshold
 * * `timed` - timed
 * @export
 */
export const SavedStateTypeEnum = {
  STABLE_THRESHOLD: "stable_threshold",
  TIMED: "timed",
} as const;
export type SavedStateTypeEnum = (typeof SavedStateTypeEnum)[keyof typeof SavedStateTypeEnum];

export function instanceOfSavedStateTypeEnum(value: any): boolean {
  for (const key in SavedStateTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(SavedStateTypeEnum, key)) {
      if (SavedStateTypeEnum[key as keyof typeof SavedStateTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SavedStateTypeEnumFromJSON(json: any): SavedStateTypeEnum {
  return SavedStateTypeEnumFromJSONTyped(json, false);
}

export function SavedStateTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SavedStateTypeEnum {
  return json as SavedStateTypeEnum;
}

export function SavedStateTypeEnumToJSON(value?: SavedStateTypeEnum | null): any {
  return value as any;
}

export function SavedStateTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SavedStateTypeEnum {
  return value as SavedStateTypeEnum;
}
